import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Journal from './pages/Journal';
import Videos from './pages/Videos';
import MoodHistory from './pages/MoodHistory';
import PrayerWall from './pages/PrayerWall';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    
    if (loading) {
        return (
            <div className="min-h-screen bg-[#FDFCF8] flex items-center justify-center">
                <div className="loading-spinner" />
            </div>
        );
    }
    
    if (!user) {
        return <Navigate to="/" replace />;
    }
    
    return (
        <div className="min-h-screen flex flex-col">
            <div className="flex-1">
                {children}
            </div>
            <Footer />
        </div>
    );
};

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route 
                path="/dashboard" 
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/journal" 
                element={
                    <ProtectedRoute>
                        <Journal />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/videos" 
                element={
                    <ProtectedRoute>
                        <Videos />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/moods" 
                element={
                    <ProtectedRoute>
                        <MoodHistory />
                    </ProtectedRoute>
                } 
            />
            <Route 
                path="/prayers" 
                element={
                    <ProtectedRoute>
                        <PrayerWall />
                    </ProtectedRoute>
                } 
            />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRoutes />
                    <Toaster 
                        position="top-center"
                        toastOptions={{
                            style: {
                                background: '#FDFCF8',
                                border: '1px solid #E6E2DD',
                                color: '#2D2A26',
                            },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
